<template>
  <div id="app" style="height:100%;">
    <loading :show="loading.status" :text="loading.text" position="absolute"></loading>
    <transition v-if="isShowView" :name="'vux-pop-' + (direction === 'forward' ? 'in' : 'out')">
      <keep-alive include="rankList">
        <router-view class="router-view"></router-view>
      </keep-alive>
    </transition>
    <confirm
      class="change-store__confirm"
      v-model="isShowChangeStore"
      title="切换门店"
      cancelText="取消"
      confirmText="确认"
      @on-cancel="handleCancel"
      @on-confirm="handleConfirm">
      <p>
        当前所在门店为
        <span class="color">{{ curStoreName }}</span>
        ，消息为{{ changeStoreName }}推送，请确定是否切换至
        <span class="color">{{ changeStoreName }}</span>
      </p>
    </confirm>
  </div>
</template>
<script>
import { Loading, Confirm } from '@lx-frontend/cvux'
import cache from '@/common/cache'
import Cookies from 'js-cookie'

export default {
  components: {
    Loading,
    Confirm
  },
  methods: {
    handleCancel () {
      this.$wechat.promise.then(wx => {
        wx.closeWindow()
        this.$emit('close')
      }, wx => {
        console.log('微信JSSDK校验错误:', wx.res)
      })
    },
    async handleConfirm () {
      try {
        const { status, code, body, data, message } = await this.$rest.auth.chooseStore(this.$store.state.fromStoreId)()
        if (status === 403) {
          this.showToast(body.message)
          return
        }
        if (code !== 0) {
          this.showToast(message)
          return
        }

        // 触发场景：
        // 已经选了某个门店
        // 打开的推送消息，不属于登录的门店
        // 需要重置 token，且要重新刷新页面，走路由鉴权、数据初始化等逻辑。
        cache.setSessionData('access_token', data['access-token'])
        cache.setLocalStorageData('last_store_id', this.$store.state.fromStoreId.toString())
        // Cookies.set('last_store_id', this.$store.state.fromStoreId.toString())
        window.location.reload()
      } catch (e) {
        this.showToast(e.message)
      }
    }
  },
  computed: {
    loading () {
      return this.$store.state.loading
    },
    direction () { // 场景动画切换方向
      return this.$store.state.direction
    },
    isShowView() { // 是否显示页面
      return this.$store.state.isShowView
    },
    isShowChangeStore() { // 是否显示切换门店框
      return this.$store.state.isShowChangeStore
    },
    curStoreName() { // 当前店铺名称
      return this.$store.state.curStoreName
    },
    changeStoreName() { // 切换门店名
      return this.$store.state.changeStoreName
    }
  }
}
</script>

<style lang="less">
@import '~@lx-frontend/cvux/src/styles/common/reset';
// @import '~@lx-frontend/cvux-theme-default/dist/index.css';
@import './stylesheets/base/fn';

body {
  background-color: #eee;
}

@keyframes popInLeft {
  from {
    transform: translate3d(-100%, 0, 0);
  }
  to {
    transform: translate3d(0, 0, 0);
  }
}
@keyframes popOutLeft {
  from {
    transform: translate3d(0, 0, 0);
  }
  to {
    transform: translate3d(-100%, 0, 0);
  }
}
@keyframes popInRight {
  from {
    transform: translate3d(100%, 0, 0);
  }
  to {
    transform: translate3d(0, 0, 0);
  }
}
@keyframes popOutRight {
  from {
    transform: translate3d(0, 0, 0);
  }
  to {
    transform: translate3d(100%, 0, 0);
  }
}
/**
* vue-router transition
*/
.router-view {
  position: relative;
  width: 100%;
  height: 100%;
  // 防止字符串 margin 往上传递，导致页面出现滚动条
  padding-top: 1/@w2;
  box-sizing: border-box;
  animation-duration: 0.5s;
  animation-fill-mode: both;
  backface-visibility: hidden;
}
.vux-pop-out-enter-active,
.vux-pop-out-leave-active,
.vux-pop-in-enter-active,
.vux-pop-in-leave-active {
  will-change: transform;
  height: 100%;
  position: absolute;
  left: 0;
}
.vux-pop-out-enter-active {
  animation-name: popInLeft;
}
.vux-pop-out-leave-active {
  animation-name: popOutRight;
}
.vux-pop-in-enter-active {
  perspective: 1000;
  animation-name: popInRight;
}
.vux-pop-in-leave-active {
  animation-name: popOutLeft;
}
.change-store__confirm {
  .color {
    color: red;
    font-weight: bold;
  }
}
</style>
